/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Steps_BodyInputs */

const en_svc_research_steps_body = /** @type {(inputs: Svc_Research_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We start from the questions you actually ask and a few briefs you would call good.`)
};

const lv_svc_research_steps_body = /** @type {(inputs: Svc_Research_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sākam no jautājumiem, ko Jūs tiešām uzdodat, un dažiem kopsavilkumiem, ko uzskatāt par labiem.`)
};

/**
* | output |
* | --- |
* | "We start from the questions you actually ask and a few briefs you would call good." |
*
* @param {Svc_Research_Steps_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_steps_body = /** @type {((inputs?: Svc_Research_Steps_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Steps_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_steps_body(inputs)
	return en_svc_research_steps_body(inputs)
});